import firebase from 'firebase'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyCTdHFefKdsM4Xg5M9k5F3_sZla-6uVMvs",
  authDomain: "enlive-c7275.firebaseapp.com",
  databaseURL: "https://enlive-c7275.firebaseio.com",
  projectId: "enlive-c7275",
  storageBucket: "enlive-c7275.appspot.com",
  messagingSenderId: "21439521175"
};
var fire = firebase.initializeApp(config);
export default fire;

export const ref = firebase.database().ref()
export const auth = firebase.auth
export const provider = new firebase.auth.FacebookAuthProvider()



// WEBPACK FOOTER //
// ./src/fire.js